import React, { ReactNode } from 'react';
import { Box, BoxProps } from '@chakra-ui/react';
import useGlassPanel from '../theme/glassPanel';

/**
 * The Sizzle-skin panel (item 46): in dark mode a translucent glass card with
 * backdrop blur floating on the ambient-glow canvas; in light mode a clean
 * white card. All content surfaces (grids, forms, settings) share this.
 * In the Accountant skin (item 61) it becomes a flat ledger panel: solid paper
 * surface, hard ink stroke, no blur.
 * item 406 — the material itself comes from useGlassPanel (the ONE glass recipe);
 * this stays the spreadable wrapper.
 */
const GlassCard: React.FC<BoxProps & { children: ReactNode }> = ({ children, ...rest }) => {
  const glass = useGlassPanel();
  return (
    // item 1510 — data-glass-card: a stable hook for the mobile layout e2e gate (every card
    // must satisfy scrollWidth <= clientWidth); no styling rides on it
    <Box data-glass-card="" {...glass} {...rest}>
      {children}
    </Box>
  );
};

export default GlassCard;
